<template>
  <!-- 公共弹窗 -->
  <!-- <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="70%"
    @ok="handleOk"
    @cancel="handleCancel"
    :footer="null"
  >-->
  <component
    :isChild="true"
    ref="componentRef"
    :is="getName"
    :dialog-visible="isVisible"
    :userEditVisiable="isVisible"
    :dictData="optionData"
    :title="title"
    :advance-type="advanceTypeList"
    :prepay-type="prepayTypeList"
    :duty-person-list="dutyPersonList"
    :client-types="clientTypes"
    :fundTypeList="fundTypeList"
    :fundTypeObj="fundTypeObj"
    :pro-type-list="proTypeList"
    @success="handleSuccuse"
    @close="handleClose"
  />
  <!-- <paymentScheduleAdd
      ref="paymentScheduleAddEdit"
      title="[新建]-付款计划"
      :dictData="[]"
      :dialog-visible="isVisible"
      @success="paymentScheduleAddclose"
  @close="paymentScheduleAddclose"/>-->
  <!-- </a-modal> -->
</template>

<script>
import paymentScheduleAdd from '@/views/purchase/paymentSchedule/addEdit.vue'
export default {
  name: 'PublicDialog',
  components: { paymentScheduleAdd },
  props: {
    componentName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '选择信息'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    },
    getName () {
      if (this.componentName) {
        return (resolve) => require([`@/views/${this.componentName}`], resolve)
      }
      return null
    }
  },
  data () {
    return {
      paymentScheduleAdd: 'paymentScheduleAdd',
      rootObj: {},
      row: {},
      clientType: [],
      clientTypes: [],
      dutyPersonList: [],
      advanceTypeList: [],
      prepayTypeList: [],
      billTypeList: [],
      fundTypeList: [],
      fundTypeObj: {},
      proTypeList: [],
      dictData: {
        comAccountList: [],
        billTypeList: [],
        paymentMethodList: [],
        returnedMoneyTypeList: [],
        returnedMoneyTypeObj: {}
      },
      optionData: {
        whetherInvoice: [
          {
            value: 0,
            item: '未开'
          },
          {
            value: 1,
            item: '已开'
          },
          {
            value: 2,
            item: '无需开票'
          }
        ],
        payStatused: [
          {
            value: 0,
            item: '未付'
          },
          {
            value: 1,
            item: '已付'
          }
        ],
        projectPhase: this.$store.state.account.dictData.projectPhaseList,
        projectStatus: this.$store.state.account.dictData.projectStatusList,
        projectType: this.$store.state.account.dictData.projectTypeList,
        signExpectation: this.$store.state.account.dictData.signExpectationList,
        subsidiaryList: this.$store.state.account.dictData.subsidiaryList
      },
      data: null,
      warehouseList: []
    }
  },
  mounted () {
    this.initDectData()
    this.initDictData()
    this.dicInit()
    this.warehouseData()
  },
  methods: {
    warehouseData (params = {}) {
      this.warehouseList = []
      this.$get('/stock/list', { ...params, pageNum: -1, pageSize: -1 }).then(res => {
        if (res.status === 200 && res.data.status === 1) {
          res.data.data.rows.forEach(item => {
            this.warehouseList.push({
              stockName: item.stockName,
              id: item.id
            })
          })
          // this.pagination.total = Number(data.data.total)
          // this.tableData = data.data.rows
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    dicInit () {
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'fundCostType' }).then(res => {
        res.data.data.forEach(item => {
          this.fundTypeList.push({
            label: item.dictName,
            value: item.dictCode
          })
          this.fundTypeObj[item.dictCode] = item.dictName
        })
      })
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'product_type' }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data
          resData.forEach(item => {
            this.proTypeList.push({
              label: item.dictName,
              value: item.dictCode
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    initDectData () {
      // 客户种类
      this.clientType = this.$store.state.account.dictData.customerTypeList
      // 离职补偿人员种类
      this.clientTypes = this.$store.state.account.dictData.dimissionTypeList
      // 项目负责人
      this.dutyPersonList = this.$store.state.account.dictData.projectPersonList
      // 预支类型字典
      this.advanceTypeList = this.$store.state.account.dictData.advanceTypeList
      // 预付类型字典
      this.prepayTypeList = this.$store.state.account.dictData.prepayTypeList
      //  票据类型
      this.billTypeList = this.$store.state.account.dictData.billTypeList
    },
    initDictData () {
      // 公司账户、票据类型、付款方式、回款分类
      let arr = ['comAccountList', 'billTypeList', 'paymentMethodList', 'returnedMoneyTypeList', 'returnedMoneyTypeObj', 'receiptsTypeList', 'subsidiaryList']
      arr.forEach((val) => {
        this.dictData[val] = this.$store.state.account.dictData[val]
      })
    },
    handleClose () {
      this.isVisible = false
    },
    advanceClose () {
      this.advanceAddVisible = false
    },
    selectClick (data) {
      this.chooseData = data
      this.handleOk()
    },
    handleOk () {
      this.$emit('logSuccess', this.chooseData, this.componentName)
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleSuccuse () {
      this.$emit('cancel')
      this.$emit('handleSuccuse', this.data.id)
      // switch (this.componentName) {
      //   case 'offices/courtesyApplication/addEdit.vue':
      //     this.$get('/festivalGift/getById', {id: this.data.id}).then(res => {
      //       if (res.data.status) {
      //         this.$nextTick(() => {
      //           this.$emit('handleSuccuse', res.data.data)
      //         })
      //       } else {
      //         this.$message.error(res.data.message)
      //       }
      //     })
      //     break
      //   default:
      //     break
      // }
    },
    edit (data) {
      this.data = data
      // console.log(this.$refs.componentRef, 'this.$refs.componentRef', this.componentName, this.title)
      setTimeout(() => {
        // this.$nextTick(() => {
        switch (this.componentName) {
          case 'financialManage/advance/addEdit.vue':
          case 'financialManage/expenseReim/addEdit.vue':
          case 'financialManage/ticketReceiptRecord/addEdit.vue':
          case 'contractManage/paymentPlan/addEdit.vue':
          case 'contractManage/paymentRecord/addEdit.vue':
          case 'purchase/purchaseRequest/addEdit.vue':
          case 'financialManage/largeAmountApplication/addEdit.vue':
          case 'purchase/supplier/supplierLink/addEdit.vue':
          case 'customerManage/linkName/addEdit.vue':
          case 'customerManage/resignationsLinkName/addEdit.vue':
          case 'customerManage/resignationsCompensation/addEdit.vue':
          case 'purchase/productManage/addEdit.vue':
          case 'salesOpportunities/ProjectResourcePool/addEdit.vue':
          case 'salesOpportunities/projectOpportunities/followRecords.vue':
          case 'contractManage/contractManagement/addEdit.vue':
            this.$refs.componentRef.setForm(data)
            break
          case 'financialManage/billingRecords/addEdit.vue':
            // console.log(data, 'data')
            this.$refs.componentRef.setForm(data)
            break
          case 'system/notice/NaticeAdd.vue':
            this.$refs.componentRef.setFormValues(data)
            break
          case 'purchase/paymentSchedule/addEdit.vue':
          case 'purchase/paymentRecords/addEdit.vue':
          case 'projectManage/humanCost/addEdit.vue':
          case 'projectManage/projectProposals/addEdit.vue':
          case 'projectManage/fundCost/addEdit.vue':
          case 'offices/operatingCosts/addEdit.vue':
          case 'projectManage/laborAndMaterial/addEdit.vue':
          case 'purchase/purchRefundRec/addEdit.vue':
          case 'inventory/prodTransRec/addEdit.vue':
          case 'manpower/recruitmentDemand/addEdit.vue':
          case 'contractManage/earnestMoney/addEdit.vue':
            this.$refs.componentRef.initData(data)
            break
          case 'inventory/transferWarehouses/addEdit.vue':
            this.$refs.componentRef.initData(data)
            break
          case 'inventory/outStock/addEdit.vue':
            this.$refs.componentRef.initData(data)
            break
          case 'inventory/storageReceipt/addEdit.vue':
            this.$refs.componentRef.initData(data)
            break
          case 'inventory/informationSettings/addEdit.vue':
            this.$refs.componentRef.initData(data)
            break
          case 'inventory/takeItBack/addEdit.vue':
            this.$refs.componentRef.initData(data)
            break
          case 'assetInformation/assetRegistration/addEdit.vue':
          case 'offices/courtesyApplication/addEdit.vue':
            this.$refs.componentRef.getDept()
            this.$refs.componentRef.initData(data)
            break
          case 'purchase/purchaseNote/sendBack.vue':
            this.$refs.componentRef.editData(data.id)
            this.$refs.componentRef.addEdited(this.warehouseList)
            break
          default:
            break
        }
      }, 500)
      // })
    }
    // setData (el) {
    //   this.$refs[el].publicDialogSucc({id: this.rootObj.projectId, subject: this.rootObj.projectName}, 'projectManage')
    //   this.$refs[el].publicDialogSucc({id: this.rootObj.supplierId, companyName: this.rootObj.suppliersName}, 'customerManage')
    // },
    // setSupplier (el) {
    //   this.$refs[el].publicDialogSucc({id: this.rootObj.projectId, subject: this.rootObj.projectName}, 'projectManage')
    //   this.$refs[el].publicDialogSucc({id: this.rootObj.supplierId, companyName: this.rootObj.suppliersName}, 'purchase/supplier')
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modelDialog/publicEditDialog.vue